import { getPrompts } from '../../api';
import { useListFetch } from '../../hooks';
import type { PromptsItem, GetPromptsFilters } from '../../api';
import type { PromptUpdatePayload, PromptCreatePayload } from '../../api';

export const usePrompts = () => {
  return useListFetch<PromptsItem, GetPromptsFilters>(
    async params => {
      const result = await getPrompts(
        params?.filters || {},
        params?.pagination
      );

      return { content: result };
    },
    {
      initialPageSize: 1_000,
      initialFilters: { campaignId: '', promptType: '' },
      withQueryParams: true,
    }
  );
};

export type Item = PromptsItem;
export type FormType = Partial<PromptsItem>;
export type CreateItem = PromptCreatePayload;
export type UpdateItem = PromptUpdatePayload;
